import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');

export function removeInvalids(params) {
    return _.omitBy(params, (param)=>{
        return (_.isUndefined(param) || _.isNull(param)|| _.isNaN(param) || (_.isString(param) && _.isEmpty(param)));
    });
}



/** WEBPACK FOOTER **
 ** ./src/app/util/lodashExtensions.ts
 **/